// 获取直播列表
export const GETLIVELIST = 'get-live-list'
// 发送直播内容
export const SENDTOCONT = 'sendto-cont'
// 发送的数据推送到列表
export const PUSHSENDTOCONT = 'push-sendto-cont'
// 直播数据排序
export const LISTRANK = 'list-rank'
// 判断是否关注
export const ISATTENTION = 'is-attention'
// 头部行情
export const MARKETLIST = 'market-list'
// 获取直播间详情
export const GETROOMBYID = 'get-room-id'
// 获取直播间人气
export const GETROOMPOPULARITY = 'get-room-popularty'
// 获取直播间列表
export const GETROOMLIVELIST = 'get-room-live-list'
// 获取自己正在使用的直播间列表
export const GETROOMLIVENOWMAINLIST = 'get-room-live-now-main-list'
// 获取直播间推荐列表
export const GETROOMLIVERECOMMENDLIST = 'get-room-live-recommend-list'
// 获取直播间类型列表
export const GETROOMLIVETYPELIST = 'get-room-live-type-list'
// 获取直播间分类列表合集
export const GETROOMLIVETYPELISTOBJDATA = 'get-room-live-type-list-obj-data'
// 获取直播间历史聊天记录
export const GETROOMCHATHISTORY = 'get-room-chat-history'
// 获取直播间人气主播列表
export const GETROOMLIVEUSERPOPULAR = 'get-room-live-use-popular'

/* ---------------------tweblive------------------ */
export const SETROLE = 'set-role'
export const SETCHATINFO = 'set-chat-info'
export const PUSHCURRENTMESSAGELIST = 'push-current-message-list'
export const PUSHCURRENTTIPSLIST = 'push-current-tips-list'
export const LIVERESET = 'live-reset'
export const ISSDKREADY = 'is-sdk-Ready'
